import { gql, useMutation } from '@apollo/client'

export const USER_PASSWORD_RESET = gql`
  mutation UserPasswordReset(
    $resetPasswordToken: String!
    $password: String!
    $passwordConfirmation: String!
    $schoolId: ID!
  ) {
    userPasswordReset(
      input: {
        resetPasswordToken: $resetPasswordToken
        password: $password
        passwordConfirmation: $passwordConfirmation
        schoolId: $schoolId
        clientMutationId: "user-password-reset"
      }
    ) {
      status
      token
      redirectUrl
      errors
    }
  }
`

export interface IUserPasswordResetResult {
  userPasswordReset: {
    status: 'success' | 'invalid_token' | 'expired_token' | 'error'
    token: string | null
    redirectUrl: string | null
    errors: string[]
  }
}

export interface IUserPasswordResetInput {
  resetPasswordToken: string
  password: string
  passwordConfirmation: string
  schoolId: string
}

export const useUserPasswordReset = () => {
  const [resetPassword, { loading, error }] =
    useMutation<IUserPasswordResetResult>(USER_PASSWORD_RESET)

  const handleResetPassword = async (input: IUserPasswordResetInput) => {
    const response = await resetPassword({ variables: input })
    return response.data?.userPasswordReset
  }

  return { handleResetPassword, loading, error }
}
